import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../../../components/Admin/GreetingsTop/GreetingsTop';
import AddQuoteForm from '../../../../components/Logistic/Quote/AddQuoteForm';
import BackButton from '../../../../components/General/BackButton/BackButton';

export default function AddQuotePage() {
  return (
    <Layout>
      <GreetingsTop />
      <HeaderTop />
      <div className="billing__container">
        <AddQuoteForm />
      </div>
    </Layout>
  );
}

function HeaderTop() {
  const { Title } = Typography;

  return (
    <div className="billing__container">
      <Row className="header-top" justify="space-between">
        <Col
          xs={18}
          md={12}
          className="header-top__left"
          style={{ position: 'relative' }}
        >
          <Title
            level={3}
            style={{
              // position: 'absolute',
              top: 0,
              bottom: 0,
              height: '78%',
              margin: 'auto',
            }}
          >
            Agregar cotización
          </Title>
        </Col>

        <Col xs={6} md={12}>
          <Row
            style={{
              marginBottom: 30,
              justifyContent: 'right',
            }}
          >
            <BackButton routeName={'/cotizacion'}></BackButton>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
